import LoopBackEndpoint from "./LoopBackEndpoint";
import { loopBackApi } from "../Api/LoopBackApi";

class RoutesEndpoint extends LoopBackEndpoint {
  public constructor() {
    super("routes", "id");
  }

  update(changedData: {}, rowData) {
    const base = this.pickMatching(changedData, this.getBaseFields());
    const promises: any[] = [];
    if (Object.keys(base).length > 0) {
      promises.push(this.patch(base, rowData));
    }

    return Promise.all(promises);
  }

  patch(base, rowData) {
    const id = rowData[this.getIndexKey()];

    if (base.temperature === undefined) {
      base.temperature = null;
    }
    if (base.actual_driven_km === undefined) {
      base.actual_driven_km = null;
    }
    if (base.comments === undefined) {
      base.comments = null;
    }

    return loopBackApi().patch("routes/by-user/" + id, base);
  }

  protected getBaseFields() {
    return ["actual_driven_km", "comments", "temperature"];
  }

  protected getRelationFields() {
    return [];
  }
}

export default RoutesEndpoint;
